import { Button, ButtonProps } from '@/components';
import { URLS } from '@/utils/constants';
import { useRouter } from 'next/router';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FaArrowRightArrowLeft } from 'react-icons/fa6';
interface TradeButtonProps extends ButtonProps {
  onClick?: () => void;
}
const TradeIcon = FaArrowRightArrowLeft as React.ComponentType<any>;
const TradeButton: ForwardRefRenderFunction<
  HTMLButtonElement,
  TradeButtonProps
> = ({ disabled, onClick: customOnClick, ...props }, ref) => {
  const router = useRouter();
  const handleClick = () => {
    if (customOnClick) {
      customOnClick();
    }
    router.push(URLS.trade);
  };
  return (
    <Button
      {...props}
      disabled={disabled}
      icon={
        <TradeIcon className={disabled ? 'text-disabled' : 'text-accent'} />
      }
      onClick={handleClick}
      iconStyles={{ intent: 'accent' }}
      ref={ref}
    >
      Trade
    </Button>
  );
};
const TradeButtonWithProps = forwardRef<HTMLButtonElement, TradeButtonProps>(
  TradeButton,
);
export default TradeButtonWithProps;
